<template>
  <div class="container">
    <div class="header">
      <div class="item">
        范围标注:{{ place.name }}
        <el-select v-model="floor_id" size="medium">
          <el-option
            v-for="(i, index) in place.floors"
            :key="index"
            :value="i.id"
            :label="i.floor"/>
        </el-select>
      </div>
      <div class="item center">
        <el-radio-group :disabled="!!share" size="medium" v-model="stage_state">
          <el-radio-button label="edit">编辑</el-radio-button>
          <el-radio-button label="view">预览</el-radio-button>
        </el-radio-group>
      </div>
      <div class="item right">
        <el-button
          v-if="stage_state === 'edit'"
          style="position: relative"
          size="medium"
          type="primary">参考图<input
            class="file-button"
            accept="image/*"
            @change="changeFile"
            type="file"></el-button>
        <el-button
          v-if="stage_state === 'edit'"
          size="medium"
          @click="save()"
          type="primary">保存</el-button>
        <el-button
          v-if="stage_state === 'edit'"
          size="medium"
          type="primary"
          @click="showUrlModal">分享链接</el-button>
      </div>
    </div>
    <div class="stage">
      <!-- <div class="canvas" ref="canvas"></div> -->
      <div ref="content" class="content"></div>
      <div v-if="stage_state === 'edit'" class="add-button">
        <el-button size="medium"
                   type="primary"
                   @click="edit('add')">添加区域</el-button>
      </div>
      <div v-if="areaModal && stage_state === 'edit'" class="area-panel">
        <div class="panel-header">
          <div class="title">信息编辑</div>
          <div @click="close" class="close"><i class="el-icon-close"></i></div>
        </div>
        <div style="margin: 8px">
          类型：
          <el-radio-group
            @change="onValueChanged"
            v-model="target.property.retain">
            <el-radio :label="true">保留</el-radio>
            <el-radio :label="false">去除</el-radio>
          </el-radio-group>
        </div>
        <div style="margin-left:8px;display:flex">
          <span>备注：</span>
          <el-input
            style="width: 74%"
            :disabled="state !== 'edit'"
            v-model="target.property.remarks"
            @change="onValueChanged"
            placeholder="请输入备注"
            type="textarea"/>
        </div>
        <div class="button-box">
          <el-button
            v-if="state === 'edit'"
            type="danger"
            @click="deleteGraphic">删除</el-button>
        </div>
      </div>
      <el-dialog title="生成链接" :visible.sync="urlModal" width="50%">
        <div class="form-item">
          <div class="form-item-title">分享链接：</div>
          <div>
            {{ url }}
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-title">
            <el-checkbox v-model="checked" @change="changeCheck">设定密码</el-checkbox>
          </div>
          <div style="width: 80%">
            <el-input style="width: 100%"
                      size="small"
                      :disabled="!checked"
                      v-model="secret" />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="urlModal = false">取 消</el-button>
          <button
            v-if="!isUrl"
            size="medium"
            type="primary"
            class="btn-copy"
            @click="createUrl($event)">
            生成链接
          </button>
          <button
            v-else
            size="medium"
            type="primary"
            @click="copy($event)"
            ref="copyBtn"
            id="copyBtn"
            class="btn-copy"
            data-clipboard-action="copy">
            复制链接
          </button>
        </span>
      </el-dialog>
    </div>
    <div v-if="useKey" class="login">
      <div class="login-form">
        <h1>Aibee</h1>
        <h3>范围标注</h3>
        <h3>{{ place.name }}</h3>
        <div>
          <el-input v-model="secret" type="password" placeholder="输入密码" />
        </div>
        <div class="button-login">
          <el-button class="btn" type="primary" @click="login">确定</el-button>
        </div>
        <div>
          <p>注：密码从管理员获取</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import { mapActions, mapGetters } from 'vuex';
import Clipboard from 'clipboard';

import Axios from 'axios';
import Stage from './core/Stege';

export default {
  computed: {
    floorId() {
      return parseInt(this.$route.query.floor_id, 10);
    },
    placeId() {
      return this.$route.query.place_id;
    },
    ...mapGetters(['token']),
  },
  watch: {
    stage_state(val) {
      this.edit(val);
    },
    floor_id(val) {
      const query = {
        ...this.$route.query,
      };
      query.floor_id = val;
      this.$router.replace({
        query,
      });
      this.secret = '';
      this.init();
    },
  },
  data() {
    return {
      place: {},
      stage: null,
      target: null,
      stage_state: 'view',
      state: null,
      picture_url: null,
      floor_id: parseInt(this.$route.query.floor_id, 10),
      share: this.$route.query.share || false,
      areaModal: false,
      urlModal: false,
      secret: '',
      url: '',
      checked: false,
      loading: false,
      clipboard: null,
      isUrl: false,
      useKey: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(['getFloorInfoInit']),
    async init(target) {
      // this.floor_id = parseInt(this.$route.query.floor_id,10)
      const res = await this.getFloorInfoInit({ place_id: this.placeId });
      const place = res.find(i => i.id === parseInt(this.placeId, 10));
      const floor = place.floors.find(
        i => i.id === parseInt(this.floorId, 10),
      );
      this.place = place;
      this.floor = floor;
      this.areaModal = false;
      this.stage_state = 'view';
      this.isUrl = false;
      this.url = '';
      this.checked = false;
      this.target = null;
      this.picture_url = null;
      const params = {
        place_id: this.placeId,
        floor_id: this.floorId,
      };
      let url = '/function/deployment-service/map_delivery/get_detail';
      if (this.share) {
        url = '/function/deployment-service/map_delivery/share';
        params.secret = this.secret;
      }
      Axios.get(url, {
        params,
        headers: {
          token: this.token,
        },
      }).then(
        (res) => {
          if (this.share) {
            this.useKey = false;
          }
          const {
            data: { data },
          } = res;
          if (data && data[0]) {
            this.result = data[0].delivery_results;
            this.picture_url = data[0].picture_url;
          } else {
            this.result = {
              point_dict: [],
              graphic_list: [],
            };
            console.log('暂无数据');
          }
          this.initStage();
        },
        (err) => {
          console.log(err.response);
          if (target === 'login') {
            this.$message.error(err.response.data.error_msg);
          }
          if (this.share) {
            this.useKey = true;
          } else {
            this.$message.error(err.response.data.error_msg);
          }
        },
      );
    },
    initStage() {
      if (this.stage) {
        this.stage.stage.destroy();
        this.stage = null;
      }
      this.stage = new Stage({
        container: this.$refs.content,
        url: this.picture_url,
        listeners: {
          errorHandler: (err) => {
            this.$message({
              type: 'error',
              message: err,
            });
          },
          changeStageState: (type) => {
            this.state = type;
          },
          areaClickHandler: (el, a, b) => {
            if (el) {
              this.areaModal = true;
              this.target = el;
            } else {
              this.areaModal = false;
              this.target = null;
            }
          },
        },
      });
      setTimeout(() => {
        this.stage.loadGraphics(this.result, 'hide');
        this.stage.viewGraphics();
      }, 500);
      console.log(this.result);
      // const target = {
      //   data: [
      //     351.473931625943,
      //     933.3639393945679,
      //     585.6648417422577,
      //     931.6545166929889,
      //     585.6648417422577,
      //     863.2776086298313,
      //     349.76450892436407,
      //     868.4058767345681,
      //     353.18335432752195,
      //     931.6545166929889,
      //     351.473931625943,
      //     933.3639393945679
      //   ],
      //   property :{ remarks: '2121',x:-351.3305459226972, y:181.79561593017334 }
      // }
      // this.stage.addArea(target)
    },
    changeCheck() {
      if (!this.checked) {
        this.secret = '';
      }
    },
    edit(type) {
      this.stage.changeStageState(type);
    },
    close() {
      this.areaModal = false;
    },
    async changeFile(e) {
      const loadingInstance = Loading.service({ fullscreen: true });
      const file = e.target.files[0];
      const param = new FormData();
      param.append('file', file);
      const config = {
        headers: { 'Content-Type': 'multipart/form-data', token: this.token },
      };
      const {
        data: { data },
      } = await Axios.post(
        '/function/deployment-service/map-delivery/upload_img_file',
        param,
        config,
      );
      await this.stage.setBackground(data);
      this.picture_url = data;
      loadingInstance.close();
    },
    onValueChanged() {
      if (this.target) {
        const k = {
          graphic_id: this.target.graphic_id,
          property: this.target.property,
        };
        this.stage.updateGraphic(k);
      }
    },
    deleteGraphic() {
      if (!this.target) return;
      this.$alert('确认删除当前标注', '提示', {
        confirmButtonText: '确定',
        callback: (action) => {
          if (action === 'confirm') {
            this.stage.deleteGraphic(this.target.graphic_id);
            this.target = null;
            this.areaModal = false;
          }
        },
      });
    },
    async save() {
      const target = {
        place_id: this.placeId,
        floor_id: this.floorId,
        picture_url: this.picture_url,
        delivery_results: JSON.stringify(this.stage.exportData()),
      };
      const { data } = await Axios.post(
        '/function/deployment-service/map_delivery/create_update_data',
        target,
        {
          headers: {
            token: this.token,
          },
        },
      );
      if (data) {
        this.$notify({
          type: 'success',
          message: '保存成功',
        });
      }
    },
    // 登录
    login() {
      if (!this.secret) {
        this.$message.error('请输入密码');
        return;
      }
      this.init('login');
    },
    showUrlModal() {
      this.urlModal = true;
      this.isUrl = false;
      this.url = '';
      this.checked = false;
      this.secret = '';
    },
    // 生成链接
    async createUrl(e) {
      if (this.loading) return;
      this.loading = true;
      if (this.checked) {
        if (this.secret === '') {
          this.$message({
            type: 'error',
            message: '请设定密码',
          });
          this.loading = false;
          return;
        }
      }
      this.url = window.location.href;
      this.url = `${this.url}&share=true`;
      const target = {
        place_id: this.placeId,
        floor_id: this.floorId,
        secret: this.secret,
      };
      const { data } = await Axios.post(
        '/function/deployment-service/map_delivery/update_secret',
        target,
        {
          headers: {
            token: this.token,
          },
        },
      );
      this.isUrl = true;
      this.loading = false;
    },
    copy(e) {
      const el = document.getElementById('copyBtn');
      el.setAttribute('data-clipboard-text', this.url);
      if (this.clipboard) return;
      this.clipboard = new Clipboard(el);
      this.clipboard.on('success', (e) => {
        this.$notify({
          message: '复制成功',
          type: 'success',
        });
        e.clearSelection();
        this.loading = false;
        this.clipboard.destroy();
        this.urlModal = false;
        setTimeout(() => {
          this.clipboard = null;
        }, 500);
      });
      this.clipboard.on('error', (e) => {
        this.clipboard.destroy();
        setTimeout(() => {
          this.clipboard = null;
        }, 500);
      });
      this.clipboard.onClick(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    box-sizing: border-box;
    padding: 0 16px;
    width: 100%;
    height: 56px;
    line-height: 56px;
    display: flex;
    justify-content: space-between;
    .item {
      width: max-content;
      min-width: 30%;
      flex: 1;
    }
    .center {
      text-align: center;
    }
    .right {
      text-align: right;
      .file-button {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }
  }
  .stage {
    box-sizing: border-box;
    border-top: 1px solid #ccc;
    position: relative;
    height: calc(100vh - 56px);
    .add-button {
      z-index: 1;
      top: 24px;
      left: 24px;
      position: absolute;
    }
    .area-panel {
      box-sizing: border-box;
      width: 240px;
      background: #fff;
      border: 1px solid #ccc;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
      z-index: 1;
      top: 24px;
      right: 24px;
      position: absolute;
      .panel-header {
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
        height: 48px;
        position: relative;
        .title {
          text-align: center;
          font-size: 16px;
          line-height: 48px;
        }
        .close {
          top: 16px;
          right: 16px;
          position: absolute;
        }
      }
      .button-box {
        text-align: center;
        padding: 8px;
      }
    }
    .content {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .canvas {
      pointer-events: none;
      z-index: 100;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
      top: 0;
      left: 0;
      position: absolute;
    }
  }
  .form-item {
    .form-item-title {
      width: 100px;
      line-height: 32px;
    }
    margin-bottom: 16px;
    display: flex;
    justify-items: center;
  }
  .btn-copy {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #dcdfe6;
    border-color: #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
    color: #ffffff;
    background-color: #2c2c2e;
    border-color: #2c2c2e;
    padding: 10px 20px;
    font-size: 14px;
    border-radius: 4px;
    margin-left: 8px;
  }
  .login {
    z-index: 100;
    position: absolute;
    background: #ffffff;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .login-form {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 400px;
      text-align: center;
      .button-login {
        margin-top: 8px;
        .btn {
          width: 100%;
        }
      }
    }
  }
}
</style>
